import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "./../component/Header";
import Sidebar from "./../component/Sidebar"; // Corrected the component name here

const removeIcon = require("./../assets/img/remove-icon.svg").default;
const viewIcon = require("./../assets/img/eye-icon.svg").default;
const backBtn = require("./../assets/img/back-btn.svg").default;

const Hsitory = () => {
  const divRef = useRef(null);
  const [userData, setUserData] = useState(null);
  const [fileDetails, setFileDetails] = useState(null);

  const { fileId } = useParams(); // Get the file name from route params

  useEffect(() => {
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    setUserData(storedUserData);

    fetch(
      `https://cliqestimatebuilder.com/waiver_admin/histories/get_by_form_key/${fileId}`,
      {
        headers: {
          Authorization: `Bearer ${storedUserData.token}`,
        },
        method: "GET",
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setFileDetails(data.data);
      })
      .catch((error) => {
        console.error("Error fetching file details:", error);
      });
  }, [fileId]);

  return (
    <div className="bodyMain">
      <div className="sideBar">
        <Sidebar />
      </div>

      <div className="contentDiv">
        <Header userData={userData} />

        <div className="mainContent" ref={divRef}>
          <div className="viewOne">
            <div className="viewOneLeft">
              <Link to="/view-forms">
                <img src={backBtn} alt="image" />
              </Link>
              <h3>History</h3>
            </div>
          </div>

          <div className="viewBox notificationDiv hstoryView">
            <ul>
              {fileDetails?.length > 0 ? (
                fileDetails.map((historyItem) => (
                  <li key={historyItem.id}>
                    <div className="notiLft">
                      <h3>{historyItem.created_at}</h3>
                      <p>
                        {historyItem.name}: {historyItem.purpose}
                      </p>
                    </div>
                  </li>
                ))
              ) : (
                <>No history found.</>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hsitory;
